import { Stack } from '@carbon/react';

import BusinessUnits from 'features/admin/groups/BusinessUnits';
import SubGroups from 'features/admin/groups/SubGroups';
import useBusinessUnitsQuery from 'shared/api/business-units/useBusinessUnitsQuery';
import styles from 'theme/features/admin/users/users-administration.module.scss';

const GroupsAdministration = () => {
  const { data: businessUnits, refetch: refetchBusinessUnits } = useBusinessUnitsQuery();

  return (
    <Stack gap={7} className={styles.wrapper}>
      <BusinessUnits
        businessUnits={businessUnits}
        isLoading={!businessUnits}
        onRefreshBusinessUnits={refetchBusinessUnits}
      />
      <SubGroups
        businessUnits={businessUnits}
        isLoading={!businessUnits}
        onRefreshBusinessUnits={refetchBusinessUnits}
      />
    </Stack>
  );
};

export default GroupsAdministration;
